var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"box-card user-card"},[_c('div',{staticClass:"content"},[_c('div',[_c('img',{staticClass:"img_",attrs:{"src":"https://www.wch.cn/img/404.dc2d93d1.png","alt":""}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }